import { render } from "./ClaimAlertsSummary.vue?vue&type=template&id=aab36428"
import script from "./ClaimAlertsSummary.vue?vue&type=script&lang=js"
export * from "./ClaimAlertsSummary.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClaimAlertsSummary.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6367f6cc%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2FClaimAlertsSummary.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__